import { Controller } from "@hotwired/stimulus"
import { useStore } from "stimulus-store"
import { sendFailureNotification } from "shared/toast_notifications"
import { getOrganizationUsers } from "shared/organization/users"
import { allUsersStore } from "../../../stores/organization/all_users_store"

// Connects to data-controller="suppliers--organization--users-supplier"
export default class extends Controller {

    static stores = [
        allUsersStore
    ]

    static values = {
        autoLoad: Boolean
    }

    connect() {
        useStore(this)

        // If autoLoad is enabled, load users immediately
        if (this.autoLoadValue) {
            this.loadUsers()
        }
    }

    /**
     * Load all users in the organization and populate the allUsersStore
     */
    async loadUsers() {
        try {
            // Fetch all users using the service
            const users = await getOrganizationUsers()

            // Update the store with fetched users
            this.setAllUsersStoreValue(users)
        } catch (error) {
            console.error('Error loading users:', {
                error: error.message,
                timestamp: new Date().toISOString()
            })

            // Show user-friendly error message
            sendFailureNotification('Unable to load users. Please try again.')

            // Clear users on error
            this.setAllUsersStoreValue([])
        }
    }

    /**
     * Manually refresh users
     */
    refreshUsers() {
        this.loadUsers()
    }

    /**
     * Clear all users from the store
     */
    clearUsers() {
        this.setAllUsersStoreValue([])
    }
}
